import { P2GLink, P2GStack, P2GText } from '@parcel2go/core-ui';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import { TranslationNamespaces } from '~/lib/constants';
import { Shop } from '~/lib/types/edge-api-types';
import { BasketQuote } from '~/lib/types/basket-types';
import { useShopSearch } from '~/hooks/use-shop-search';
import { useDistance } from '@parcel2go/npm-p2g-app';

function QuoteCardServiceTypeDropOff({
  onDropoff,
  shops,
  quote
}: {
  onDropoff?: () => void;
  shops: Shop[];
  quote: BasketQuote;
}) {
  const { t } = useTranslation([TranslationNamespaces.QUOTE]);
  const { searchedShopProviders } = useShopSearch();
  const { toDistance } = useDistance();

  const displayShops = useMemo(() => {
    if (shops?.length > 0) {
      return shops.sort((a, b) => a.distance - b.distance);
    } else if (searchedShopProviders) {
      const quoteProvider = quote.service?.dropOffProviderGroup;
      if (quoteProvider && searchedShopProviders[quoteProvider]) {
        return [...searchedShopProviders[quoteProvider]].sort((a, b) => a.distance - b.distance);
      }
    }
    return [];
  }, [shops, searchedShopProviders, quote]);

  return (
    <P2GStack sx={{ flexDirection: 'column', flexWrap: 'no-wrap' }}>
      <P2GText
        className="text-secondary"
        sx={{
          '&.MuiTypography-root': {
            fontSize: '14px',
            fontWeight: 'bold'
          }
        }}
      >
        {t('DROP_OFF', { defaultValue: 'Drop Off' })}
      </P2GText>
      {displayShops?.length > 0 && (
        <P2GLink
          sx={{
            '&.MuiTypography-root': {
              fontSize: '12px'
            }
          }}
          onClick={onDropoff}
        >
          {t('DROP_OFF_NEAREST_DISTANCE', {
            defaultValue: 'Nearest: {{distance}}',
            distance: toDistance(displayShops[0].distance, 'small')
          })}
        </P2GLink>
      )}
      {displayShops?.length === 0 && (
        <P2GText
          sx={{
            '&.MuiTypography-root': {
              fontSize: '12px'
            }
          }}
        >
          {t('NO_SHOPS', { defaultValue: 'No shops found' })}
        </P2GText>
      )}
      {!displayShops?.length && (
        <P2GLink
          sx={{
            '&.MuiTypography-root': {
              fontSize: '12px'
            }
          }}
          onClick={onDropoff}
        >
          {t('FIND_SHOPS_NEARBY_LINK', { defaultValue: 'Find shops nearby' })}
        </P2GLink>
      )}
    </P2GStack>
  );
}

export default QuoteCardServiceTypeDropOff;
